/* eslint-disable max-params */
import { API, Auth } from "aws-amplify";
import { TypeCommon } from "models/common";

export const getAccessJwtToken = async (): Promise<TypeCommon> => {
  try {
    const session: TypeCommon = await Auth.currentSession();
    const newtoken = session?.getIdToken().getJwtToken();
    return newtoken;
  } catch (err) {
    return "";
  }
};

export const get = async (
  apiName: string,
  url: string,
  params?: TypeCommon,
  headers?: TypeCommon,
  currentToken?: string,
): Promise<TypeCommon> => {
  const token = currentToken || (await getAccessJwtToken());
  return API.get(apiName, url, {
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};

export const post = async (
  apiName: string,
  url: string,
  body: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
): Promise<TypeCommon> => {
  const token = await getAccessJwtToken();
  return API.post(apiName, url, {
    body,
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};

export const put = async (
  apiName: string,
  url: string,
  body: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
): Promise<TypeCommon> => {
  const token = await getAccessJwtToken();
  return API.put(apiName, url, {
    body,
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};

export const del = async (
  apiName: string,
  url: string,
  body: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
): Promise<TypeCommon> => {
  const token = await getAccessJwtToken();
  return API.del(apiName, url, {
    body,
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};
export const uploadImage = async (
  imageName: string,
  file: TypeCommon,
): Promise<void> => {
  const data = await post("form", "/presigned-url", {
    key: imageName,
  });
  const formData = new FormData();
  Object.entries(data?.data.fields).forEach(([key, value]) => {
    formData.append(key, value as TypeCommon);
  });
  formData.append("file", file);
  if (data?.data) {
    await fetch(data?.data?.url, {
      method: "POST",
      body: formData,
    });
  }
};
